import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Card, CardHeader, Button, Divider, } from '@mui/material';

import Breadcrumbs from 'config/Breadcrumb';

const ViewSCAReportData = () => {
    // useLocation Hook
    const location = useLocation();
    const reportData = location.state?.data;
    const agentName = location.state?.name;

    // State Variables
    const [expandCard1, setExpandCard1] = useState(false);
    const [expandCard2, setExpandCard2] = useState(false);
    const [expandCard3, setExpandCard3] = useState(false);
    const [currentPath, setCurrentPath] = useState(['SCA Report']);

    const result = reportData?.result
        ? reportData.result.charAt(0).toUpperCase() + reportData.result.slice(1)
        : '';

    // Method handles the color based on the policy result
    const getColor = (result) => {
        switch (result?.toLowerCase()) {
            case 'passed':
                return { color: 'green' };
            case 'failed':
                return { color: 'red' };
            case 'not applicable':
                return { color: 'grey' };
            default:
                return { color: 'black' }; 
        }
    }

    // Updates the bread scrums
    useEffect(() => {
        setCurrentPath(['SCA Report', 'View Report', ` ${agentName}`])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div >
            <Card >
                <CardHeader
                    title={
                        <React.Fragment>
                            <div
                                className="d-flex align-items-center justify-content-between"
                                style={{
                                    width: '100%',
                                }}
                            >
                                <div>
                                    <Breadcrumbs paths={currentPath} />
                                </div>
                                <div>
                                    <Button
                                        variant="contained"
                                        className="back font"
                                        onClick={() => window.history.back()}
                                    >
                                        Back
                                    </Button>
                                </div>
                            </div>
                        </React.Fragment>
                    }
                />
            </Card>
            <Divider className="divider" />
            <div className=' m-4 d-flex justify-content-center align-items-center' >
                <Card className='p-4' style={{ width: '75%' }}>
                    {reportData && (
                        <>
                            <p className='row'><strong className="word-wrap col-2">Title:</strong><p className='col'>{reportData?.title}</p></p>
                            <p className='mt-2 row'><strong className="word-wrap col-2">Target:</strong>
                                <p className='col word-wrap'>{reportData?.command ? (
                                    <>  {reportData?.command}</>
                                ) : reportData?.registry ? (
                                    <>  {reportData?.registry}</>
                                ) : reportData?.file ? (
                                    <>  {reportData?.file}</>
                                ) : reportData?.process ? (
                                    <>  {reportData?.process}</>
                                ) : reportData?.directory ? (
                                    <>  {reportData?.directory}</>
                                ) : (
                                    <span></span>  // Fallback if none of the properties are present
                                )}</p>
                            </p>
                            <p className='row'><strong className="word-wrap col-2">Result:</strong> <p style={getColor(reportData?.result)} className='col'>
                                {result}
                            </p></p>

                            <p className='row'>
                                { reportData?.description && (<strong className="word-wrap col-2">Description:</strong>)}

                                {reportData?.description?.length > 250 && !expandCard1 ? (
                                    <p className='col'>
                                        {reportData?.description.slice(0, 250)}...
                                        <span
                                            onClick={() => { setExpandCard1(!expandCard1) }}
                                            className='expand-more '
                                        >
                                            Read more
                                        </span>
                                    </p>
                                ) : (
                                    <p className='col'>{reportData?.description}</p>
                                )}

                            </p>
                            <p className='row'>
                               { reportData?.rationale && (<strong className="word-wrap col-2">Rationale:</strong>)}

                                {reportData?.rationale.length > 250 && !expandCard2 ? (
                                    <p className='col'>
                                        {reportData?.rationale.slice(0, 250)}...
                                        <span
                                            onClick={() => { setExpandCard2(!expandCard2) }}
                                            className='expand-more'                               >
                                            Read more
                                        </span>
                                    </p>
                                ) : (
                                    <p className='col'>{reportData?.rationale}</p>
                                )}

                            </p>

                            <p className='row'>
                                <strong className="word-wrap col-2">Remediation:</strong>

                                {reportData?.remediation.length > 250 && !expandCard3 ? (
                                    <p className='col'>
                                        {reportData?.remediation.slice(0, 250)}...
                                        <span
                                            onClick={() => { setExpandCard3(!expandCard3) }}
                                            className='expand-more' 
                                        >
                                            Read more
                                        </span>
                                    </p>
                                ) : (
                                    <p className='col'>{reportData?.remediation}</p>
                                )}

                            </p>
                        </>

                    )}
                </Card>


            </div>

        </div>
    )
}

export default ViewSCAReportData;